module.exports = __webpack_public_path__ + "static/media/ardr.7ab213e9.svg";